const H7 = "\x07";
const FS = "\x1C";

const pad4 = (n) => String(n).padStart(4, "0");

const byteLenUtf8 = (s) => new TextEncoder().encode(s).length;

export const makeSendData = (senddata) => {
  const bodyLen = byteLenUtf8(senddata);
  const totLen = 12 + bodyLen;
  return pad4(totLen) + "VCAT    " + pad4(bodyLen) + senddata;
};

export const buildCreditApproveMsg = ({
  money,
  tax = "0",
  bongsa = "0",
  halbu = "00",
}) => {
  return (
    "NICEVCAT" +
    H7 +
    "0200" +
    FS +
    "10" +
    FS +
    "C" +
    FS +
    money +
    FS +
    tax +
    FS +
    bongsa +
    FS +
    halbu +
    FS +
    "" +
    FS +
    "" +
    FS +
    "" +
    FS +
    "" +
    FS +
    FS +
    FS +
    "" +
    FS +
    FS +
    FS +
    FS +
    "" +
    FS +
    H7
  );
};

export const parseNvcatResponse = (raw) => {
  if (!raw || raw.length < 16) {
    return { ok: false, error: "응답 길이가 비정상입니다.", raw };
  }

  const header = {
    totalLen: raw.slice(0, 4),
    magic: raw.slice(4, 12),
    bodyLen: raw.slice(12, 16),
  };

  const body = raw.slice(16);
  const parts = body.split(FS).map((s) => (s ?? "").trim());

  const resultCode = parts[2] || "";
  const ok = resultCode === "0000";

  const parsed = {
    mti: parts[0] || "",
    trxType: parts[1] || "",
    resultCode,
    amount: parts[3] || "",
    halbu: parts[6] || "",
    approvalNo: parts[7] || "",
    approvedAtRaw: parts[8] || "",
    cardName: parts[10] || "",
    catId: parts[14] || "",
    message: parts[16] || "",
    cardNoMasked: parts[17] || "",
  };

  return { ok, header, body, parts, parsed, raw };
};

export const formatApprovedAt = (yyMMddHHmmss) => {
  if (!/^\d{12}$/.test(yyMMddHHmmss)) return yyMMddHHmmss;

  const yy = yyMMddHHmmss.slice(0, 2);
  const MM = yyMMddHHmmss.slice(2, 4);
  const dd = yyMMddHHmmss.slice(4, 6);
  const HH = yyMMddHHmmss.slice(6, 8);
  const mm = yyMMddHHmmss.slice(8, 10);
  const ss = yyMMddHHmmss.slice(10, 12);

  return `20${yy}-${MM}-${dd} ${HH}:${mm}:${ss}`;
};

export const requestNvcat9188 = async (sendMsg) => {
  const payload = encodeURI(makeSendData(sendMsg));

  const res = await fetch("http://127.0.0.1:9188", {
    method: "POST",
    headers: {
      "Content-Type": "text/plain;charset=UTF-8",
    },
    body: payload,
  });

  const text = await res.text();
  return text;
};

export const requestCardApprove = async ({
  amount,
  tax = "0",
  bongsa = "0",
  halbu = "00",
  debug = true,
}) => {
  const money = String(amount);

  const sendMsg = buildCreditApproveMsg({
    money,
    tax,
    bongsa,
    halbu,
  });

  if (debug) {
    console.log("[NVCAT] sendMsg(body):", sendMsg);
    console.log("[NVCAT] sendData(payload):", makeSendData(sendMsg));
  }

  const raw = await requestNvcat9188(sendMsg);

  if (debug) {
    console.log("[NVCAT] raw response:", raw);
  }

  const parsed = parseNvcatResponse(raw);

  if (debug) {
    console.log("[NVCAT] parsed:", parsed);
  }

  if (!parsed.ok) {
    const err = new Error(
      `결제 실패(${parsed.parsed?.resultCode || "NO_CODE"}) ${parsed.parsed?.message || ""}`
    );
    err.code = parsed.parsed?.resultCode || "NO_CODE";
    err.raw = raw;
    err.parsed = parsed;
    throw err;
  }

  return {
    approvalNo: parsed.parsed.approvalNo,
    approvedAt: formatApprovedAt(parsed.parsed.approvedAtRaw),
    cardName: parsed.parsed.cardName,
    cardNoMasked: parsed.parsed.cardNoMasked,
    catId: parsed.parsed.catId,
    amount: Number(parsed.parsed.amount || amount),
    resultCode: parsed.parsed.resultCode,
    rawResponse: raw,
  };
};